import { take } from 'rxjs/operators';
import { BlockUi } from './../../auth/_helpers/block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { Vet } from './../../auth/_models/vet';
import { Component, OnInit } from '@angular/core';
import { VetsService } from 'src/app/auth/_services/vets.service';

@Component({
  selector: 'app-vet-registration',
  templateUrl: './vet-registration.component.html',
  styleUrls: ['./vet-registration.component.css']
})
export class VetRegistrationComponent implements OnInit {

  vet: Vet;
  num1;
  num2;
  operator;
  result: number;
  answer: number;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _vetsService: VetsService,
    private _blockUi: BlockUi
  ) { }

  generateOperation() {
    this.num1 = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    this.num2 = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    const ops = ['+', '-'];

    const opindex = Math.floor(Math.random() * 2);
    this.operator = ops[opindex];

    switch (opindex) {
      case 0: this.result = this.num1 + this.num2; break;
      case 1: this.result = this.num1 - this.num2; break;
    }
  }

  ngOnInit() {
    this.generateOperation();
    this._activatedRoute.parent.params.subscribe(params => {
      const uuid = params['id'];
      console.log(uuid);
      this._vetsService.getVet(uuid)
        .snapshotChanges()
        .subscribe(vet => {
          this.vet = new Vet({ ...{ uuid: vet.payload.id }, ...vet.payload.data() });
          console.log(this.vet);
        });
    });
  }

  deleteVet(vet: Vet) {

    if (this.answer === this.result) {
      if (vet) {
        this._blockUi.block();
        this._vetsService.deleteVet(vet)
          .then(function () {
          }).catch(error => {
            console.log('ERRO:', error);
          });
        this._blockUi.unblock();
        this._router.navigateByUrl('veterinarios/listar');
      } else {
        this._blockUi.unblock();
      }
    } else {
      this.answer = null;
      this.generateOperation();
    }

  }

}
